import $http from "../../axios";
import { Notification } from "element-ui";
import {slearState} from "./mutations";
export async function searchProducts ({state,commit}, filter) {
    let params ={
        filter : filter,
        paginate : false,
        branchoffice_id: localStorage.selected_branchoffice,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
    }
    await $http.get('/api/lista-productos', {params}).then((response) => {
        commit("setProducts", response.data.data.data);
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}
export async function fetchVoucherTypes({state, rootState, commit}) {
    if (state.params.branch_office_id) {
        await $http.get("/api/tipos-de-comprobantes", {params: {paginate: false, branchoffice: state.params.branch_office_id}}).then(response => {
            commit("setVoucherTypes", response.data.data);
        }).catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
    }
}
export async function fetchDocuments({state, rootState, commit}) {
    if (state.params.branch_office_id && state.params.voucher_type_id) {
        await $http.get("/api/refactorizar/get-documentos", {params: {voucherType: state.params.voucher_type_id, branch: state.params.branch_office_id}}).then(response => {
            commit("setDocuments", response.data.data);
        }).catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
    }
}
export async function fetchBranchOffices({ commit, state },) {
    await $http
        .get("/api/sedes?paginate=false")
        .then(response => {
            commit("setBranchOffices_refactor", response.data.data);
        }).catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}
export async function rebuild({ state, commit }, filter) {
let params = state.params

await $http.get("/api/reconstructor-global", { params }).then(response => {
    Notification.success({
        title: "Exito!",
        message:`Ha iniciado la reconstruccion por ${params.type_refactor}`,
        type: "success",
        duration: 1500,
        customClass: "notification-box"
      });
    commit("slearState");
})
.catch(error => {
    let data = error.response.data;
    Notification.error({
      title: "Error!",
      message: data ? data : error.message,
      type: "error",
      duration: 3000,
      customClass: "notification-box"
    });
});
}



// WEBPACK FOOTER //
// ./src/modules/rebuild/actions.js